import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation } from "@tanstack/react-query"

import type {
  UpdateModuleInverterEquipmentDto,
  UpdateModuleInverterEquipmentResponseDto,
} from "~/api/dto/equipment-dto"
import { equipmentService } from "~/api/services/equipment.service"

type UpdateModuleInverterEquipmentVariables = {
  proposalId: string
  designId: string
  payload: UpdateModuleInverterEquipmentDto
}

export default function useUpdateModuleInverterEquipment(options?: {
  onError?: (error: unknown) => void
}): UseMutationResult<
  UpdateModuleInverterEquipmentResponseDto,
  unknown,
  UpdateModuleInverterEquipmentVariables
> {
  return useMutation({
    mutationFn: ({ proposalId, designId, payload }) =>
      equipmentService.updateModuleInverterEquipment(
        proposalId,
        designId,
        payload,
      ),
    onError: options?.onError,
  })
}
